import { combineReducers } from 'redux'
import { app } from './app'
import { marketing } from './marketing'
import { registration } from './registration'
import { simulation } from './simulation'

export const reducers = combineReducers({
  app,
  marketing,
  simulation,
  registration
})
